import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { currentUserPersonQuery } from '../../../api/index.js'
import { IconPerson } from '../../../common/icons.jsx'
import { eSalaryImage } from '../../../common/utils.jsx'
import { authSelector } from '../../../reducers/index.js'

export const UserAvatar = ({ customImage, customName }) => {
	const { fullName, eSalaryCompanyId, employeeNumber } = useSelector(authSelector)

	const getCustomImage = () => {
		if (customImage && customImage.length > 0) {
			return customImage
		}
		return undefined
	}

	const isPersonal = location.pathname.startsWith('/personal')
	const { data: personData } = useQuery(currentUserPersonQuery(isPersonal && employeeNumber))
	const personImage = customImage ? getCustomImage() : isPersonal ? personData?.otherDetails?.image : null
	const name = customName ? customName : fullName

	return (
		<div className="d-flex align-items-center mb-2 gap-2">
			{personImage ? (
				<img
					src={eSalaryImage(eSalaryCompanyId, personImage)}
					crossOrigin="anonymous"
					alt="Profile"
					width={45}
					height={45}
					className="rounded-circle"
					style={{ objectFit: 'cover' }}
				/>
			) : (
				<IconPerson className="personal-profile-image" />
			)}
			<strong>{name}</strong>
		</div>
	)
}
